export const MENU_LANG_META = {
    ro: { label: 'Română', native: 'Română', flag: '🇷🇴', flagIso: 'ro' },
    en: { label: 'English', native: 'English', flag: '🇬🇧', flagIso: 'gb' },
    de: { label: 'German', native: 'Deutsch', flag: '🇩🇪', flagIso: 'de' },
    fr: { label: 'French', native: 'Français', flag: '🇫🇷', flagIso: 'fr' },
    it: { label: 'Italian', native: 'Italiano', flag: '🇮🇹', flagIso: 'it' },
    hu: { label: 'Hungarian', native: 'Magyar', flag: '🇭🇺', flagIso: 'hu' },
    es: { label: 'Spanish', native: 'Español', flag: '🇪🇸', flagIso: 'es' },
    bg: { label: 'Bulgarian', native: 'Български', flag: '🇧🇬', flagIso: 'bg' },
    tr: { label: 'Turkish', native: 'Türkçe', flag: '🇹🇷', flagIso: 'tr' },
    zh: { label: 'Chinese', native: '中文', flag: '🇨🇳', flagIso: 'cn' },
    ja: { label: 'Japanese', native: '日本語', flag: '🇯🇵', flagIso: 'jp' },
    ko: { label: 'Korean', native: '한국어', flag: '🇰🇷', flagIso: 'kr' },
};

export function menuFlagUrl(code, width = 40) {
    const iso = MENU_LANG_META[code]?.flagIso || code;
    const w = Math.max(20, Math.min(width, 80));
    return `https://flagcdn.com/w${w}/${iso}.png`;
}

const STRINGS = {
    ro: {
        language: 'Limbă',
        previewError: 'Preview meniu indisponibil. Logează-te ca super admin sau scanează un QR real.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Restaurant închis',
        closedFallback: 'Comenzile prin QR nu sunt disponibile momentan.',
        table: 'Masa',
        welcome: 'Bine ai venit! Alege din meniu și comanda ajunge direct la bucătărie.',
        hoursToday: 'Program azi',
        activeOrder: 'Ai o comandă activă (#{{id}}). Ce adaugi acum se va alătura.',
        fromPrice: 'de la',
        emptyCategory: 'Categoria e goală.',
        yourOrders: 'Comenzile tale',
        orderItems: '{{count}} produse',
        cartFilled: 'Coș ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Coș gol',
        billTitle: 'Ceri nota?',
        billHint: 'Alege cum vrei să plătești. Ospătarul va primi notificarea cu metoda aleasă.',
        cash: 'Numerar',
        cashHint: 'Plată cash la masă',
        card: 'Card',
        cardHint: 'Plată cu cardul (POS)',
        billSentTitle: 'Nota a fost cerută',
        billSentHint: 'Ospătarul vine în câteva momente.',
        ok: 'OK',
        chooseVariant: 'Alege varianta',
        addToCart: 'Adaugă în coș',
        addProduct: 'Adaugă produsul',
        cartTitle: 'Coș comandă',
        total: 'Total',
        addToActiveOrder: 'Adaugă la comanda activă',
        sendOrder: 'Trimite comanda',
        orderSentTitle: 'Comanda a plecat!',
        orderSentHint: 'Ospătarul a fost notificat. #{{id}}',
        thanks: 'Mulțumesc',
        callWaiter: 'Cheamă ospătar',
        requestBill: 'Cere nota',
        waiterCalled: 'Ospătarul a fost anunțat. Vine în câteva momente.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Alergeni',
        description: 'Descriere',
        ingredients: 'Ingrediente',
        nutrition: 'Valori nutriționale',
        tags: 'Tag-uri',
        detailsTitle: 'Detalii',
        bookTable: 'Rezervă o masă',
        showNutrition: 'Afișează valorile nutriționale',
        hideNutrition: 'Ascunde valorile nutriționale',
        wifi: 'Wi-Fi',
        wifiPassword: 'Parolă',
        status: {
            PENDING: 'Nouă',
            CONFIRMED: 'Confirmată',
            IN_KITCHEN: 'În bucătărie',
            READY: 'Gata',
            SERVED: 'Servită',
            PAID: 'Plătită',
            CANCELLED: 'Anulată',
        },
    },
    en: {
        language: 'Language',
        previewError: 'Menu preview unavailable. Log in as super admin or scan a real QR code.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Restaurant closed',
        closedFallback: 'QR ordering is not available right now.',
        table: 'Table',
        welcome: 'Welcome! Browse the menu and your order goes straight to the kitchen.',
        hoursToday: 'Hours today',
        activeOrder: 'You have an active order (#{{id}}). New items will be added to it.',
        fromPrice: 'from',
        emptyCategory: 'This category is empty.',
        yourOrders: 'Your orders',
        orderItems: '{{count}} items',
        cartFilled: 'Cart ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Cart empty',
        billTitle: 'Request the bill?',
        billHint: 'Choose how you want to pay. Your waiter will be notified.',
        cash: 'Cash',
        cashHint: 'Pay cash at the table',
        card: 'Card',
        cardHint: 'Pay by card (POS)',
        billSentTitle: 'Bill requested',
        billSentHint: 'Your waiter is on the way.',
        ok: 'OK',
        chooseVariant: 'Choose a size',
        addToCart: 'Add to cart',
        addProduct: 'Add item',
        cartTitle: 'Your cart',
        total: 'Total',
        addToActiveOrder: 'Add to active order',
        sendOrder: 'Place order',
        orderSentTitle: 'Order sent!',
        orderSentHint: 'Your waiter has been notified. #{{id}}',
        thanks: 'Thank you',
        callWaiter: 'Call waiter',
        requestBill: 'Request bill',
        waiterCalled: 'Waiter notified. They will be with you shortly.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Allergens',
        description: 'Description',
        ingredients: 'Ingredients',
        nutrition: 'Nutritional values',
        tags: 'Tags',
        detailsTitle: 'Details',
        bookTable: 'Book a table',
        showNutrition: 'Show nutritional values',
        hideNutrition: 'Hide nutritional values',
        wifi: 'Wi-Fi',
        wifiPassword: 'Password',
        status: {
            PENDING: 'New',
            CONFIRMED: 'Confirmed',
            IN_KITCHEN: 'In kitchen',
            READY: 'Ready',
            SERVED: 'Served',
            PAID: 'Paid',
            CANCELLED: 'Cancelled',
        },
    },
    de: {
        language: 'Sprache',
        previewError: 'Menüvorschau nicht verfügbar.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Restaurant geschlossen',
        closedFallback: 'QR-Bestellungen sind derzeit nicht möglich.',
        table: 'Tisch',
        welcome: 'Willkommen! Wählen Sie aus der Speisekarte — die Bestellung geht direkt in die Küche.',
        hoursToday: 'Heute geöffnet',
        activeOrder: 'Aktive Bestellung (#{{id}}). Neue Artikel werden hinzugefügt.',
        fromPrice: 'ab',
        emptyCategory: 'Diese Kategorie ist leer.',
        yourOrders: 'Ihre Bestellungen',
        orderItems: '{{count}} Artikel',
        cartFilled: 'Warenkorb ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Warenkorb leer',
        billTitle: 'Rechnung anfordern?',
        billHint: 'Wählen Sie die Zahlungsart. Der Kellner wird benachrichtigt.',
        cash: 'Bar',
        cashHint: 'Bar am Tisch bezahlen',
        card: 'Karte',
        cardHint: 'Mit Karte bezahlen (POS)',
        billSentTitle: 'Rechnung angefordert',
        billSentHint: 'Der Kellner kommt gleich.',
        ok: 'OK',
        chooseVariant: 'Größe wählen',
        addToCart: 'In den Warenkorb',
        addProduct: 'Hinzufügen',
        cartTitle: 'Warenkorb',
        total: 'Gesamt',
        addToActiveOrder: 'Zur aktiven Bestellung',
        sendOrder: 'Bestellung senden',
        orderSentTitle: 'Bestellung gesendet!',
        orderSentHint: 'Kellner benachrichtigt. #{{id}}',
        thanks: 'Danke',
        callWaiter: 'Kellner rufen',
        requestBill: 'Rechnung',
        waiterCalled: 'Kellner benachrichtigt. Er kommt gleich.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Allergene',
        description: 'Beschreibung',
        ingredients: 'Zutaten',
        nutrition: 'Nährwertangaben',
        tags: 'Tags',
        status: {
            PENDING: 'Neu', CONFIRMED: 'Bestätigt', IN_KITCHEN: 'In der Küche',
            READY: 'Fertig', SERVED: 'Serviert', PAID: 'Bezahlt', CANCELLED: 'Storniert',
        },
    },
    fr: {
        language: 'Langue',
        previewError: 'Aperçu du menu indisponible.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Restaurant fermé',
        closedFallback: 'Les commandes QR ne sont pas disponibles pour le moment.',
        table: 'Table',
        welcome: 'Bienvenue ! Parcourez le menu — la commande part directement en cuisine.',
        hoursToday: 'Horaires du jour',
        activeOrder: 'Commande active (#{{id}}). Les nouveaux articles seront ajoutés.',
        fromPrice: 'dès',
        emptyCategory: 'Cette catégorie est vide.',
        yourOrders: 'Vos commandes',
        orderItems: '{{count}} articles',
        cartFilled: 'Panier ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Panier vide',
        billTitle: 'Demander l\'addition ?',
        billHint: 'Choisissez le mode de paiement. Le serveur sera notifié.',
        cash: 'Espèces',
        cashHint: 'Payer en espèces à table',
        card: 'Carte',
        cardHint: 'Payer par carte (TPE)',
        billSentTitle: 'Addition demandée',
        billSentHint: 'Le serveur arrive dans un instant.',
        ok: 'OK',
        chooseVariant: 'Choisir la taille',
        addToCart: 'Ajouter au panier',
        addProduct: 'Ajouter',
        cartTitle: 'Panier',
        total: 'Total',
        addToActiveOrder: 'Ajouter à la commande active',
        sendOrder: 'Commander',
        orderSentTitle: 'Commande envoyée !',
        orderSentHint: 'Serveur notifié. #{{id}}',
        thanks: 'Merci',
        callWaiter: 'Appeler serveur',
        requestBill: 'Addition',
        waiterCalled: 'Serveur notifié. Il arrive dans un instant.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Allergènes',
        description: 'Description',
        ingredients: 'Ingrédients',
        nutrition: 'Valeurs nutritionnelles',
        tags: 'Tags',
        status: {
            PENDING: 'Nouvelle', CONFIRMED: 'Confirmée', IN_KITCHEN: 'En cuisine',
            READY: 'Prête', SERVED: 'Servie', PAID: 'Payée', CANCELLED: 'Annulée',
        },
    },
    it: {
        language: 'Lingua',
        previewError: 'Anteprima menu non disponibile.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Ristorante chiuso',
        closedFallback: 'Gli ordini QR non sono disponibili al momento.',
        table: 'Tavolo',
        welcome: 'Benvenuto! Sfoglia il menu — l\'ordine va direttamente in cucina.',
        hoursToday: 'Orari di oggi',
        activeOrder: 'Ordine attivo (#{{id}}). I nuovi articoli verranno aggiunti.',
        fromPrice: 'da',
        emptyCategory: 'Questa categoria è vuota.',
        yourOrders: 'I tuoi ordini',
        orderItems: '{{count}} articoli',
        cartFilled: 'Carrello ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Carrello vuoto',
        billTitle: 'Chiedere il conto?',
        billHint: 'Scegli come pagare. Il cameriere riceverà la notifica.',
        cash: 'Contanti',
        cashHint: 'Paga in contanti al tavolo',
        card: 'Carta',
        cardHint: 'Paga con carta (POS)',
        billSentTitle: 'Conto richiesto',
        billSentHint: 'Il cameriere sta arrivando.',
        ok: 'OK',
        chooseVariant: 'Scegli la variante',
        addToCart: 'Aggiungi al carrello',
        addProduct: 'Aggiungi',
        cartTitle: 'Carrello',
        total: 'Totale',
        addToActiveOrder: 'Aggiungi all\'ordine attivo',
        sendOrder: 'Invia ordine',
        orderSentTitle: 'Ordine inviato!',
        orderSentHint: 'Cameriere notificato. #{{id}}',
        thanks: 'Grazie',
        callWaiter: 'Chiama cameriere',
        requestBill: 'Conto',
        waiterCalled: 'Cameriere notificato. Arriva tra poco.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Allergeni',
        description: 'Descrizione',
        ingredients: 'Ingredienti',
        nutrition: 'Valori nutrizionali',
        tags: 'Tag',
        status: {
            PENDING: 'Nuovo', CONFIRMED: 'Confermato', IN_KITCHEN: 'In cucina',
            READY: 'Pronto', SERVED: 'Servito', PAID: 'Pagato', CANCELLED: 'Annullato',
        },
    },
    hu: {
        language: 'Nyelv',
        previewError: 'Menü előnézet nem elérhető.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Az étterem zárva',
        closedFallback: 'A QR rendelés jelenleg nem elérhető.',
        table: 'Asztal',
        welcome: 'Üdvözöljük! Válasszon az étlapról — a rendelés egyenesen a konyhába megy.',
        hoursToday: 'Mai nyitvatartás',
        activeOrder: 'Aktív rendelés (#{{id}}). Az új tételek hozzáadódnak.',
        fromPrice: 'tól',
        emptyCategory: 'Ez a kategória üres.',
        yourOrders: 'Rendelései',
        orderItems: '{{count}} tétel',
        cartFilled: 'Kosár ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Üres kosár',
        billTitle: 'Számlát kér?',
        billHint: 'Válassza ki a fizetési módot. A pincér értesítést kap.',
        cash: 'Készpénz',
        cashHint: 'Fizetés készpénzzel az asztalnál',
        card: 'Kártya',
        cardHint: 'Fizetés kártyával (POS)',
        billSentTitle: 'Számla kérve',
        billSentHint: 'A pincér úton van.',
        ok: 'OK',
        chooseVariant: 'Válasszon méretet',
        addToCart: 'Kosárba',
        addProduct: 'Hozzáadás',
        cartTitle: 'Kosár',
        total: 'Összesen',
        addToActiveOrder: 'Hozzáadás az aktív rendeléshez',
        sendOrder: 'Rendelés küldése',
        orderSentTitle: 'Rendelés elküldve!',
        orderSentHint: 'Pincér értesítve. #{{id}}',
        thanks: 'Köszönjük',
        callWaiter: 'Pincért hív',
        requestBill: 'Számla',
        waiterCalled: 'Pincér értesítve. Hamarosan jön.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Allergének',
        description: 'Leírás',
        ingredients: 'Összetevők',
        nutrition: 'Tápanyagok',
        tags: 'Címkék',
        status: {
            PENDING: 'Új', CONFIRMED: 'Megerősítve', IN_KITCHEN: 'Konyhában',
            READY: 'Kész', SERVED: 'Kiszolgálva', PAID: 'Fizetve', CANCELLED: 'Törölve',
        },
    },
    es: {
        language: 'Idioma',
        previewError: 'Vista previa del menú no disponible.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Restaurante cerrado',
        closedFallback: 'Los pedidos por QR no están disponibles ahora.',
        table: 'Mesa',
        welcome: '¡Bienvenido! Elige del menú — el pedido va directo a cocina.',
        hoursToday: 'Horario de hoy',
        activeOrder: 'Pedido activo (#{{id}}). Los nuevos artículos se añadirán.',
        fromPrice: 'desde',
        emptyCategory: 'Esta categoría está vacía.',
        yourOrders: 'Tus pedidos',
        orderItems: '{{count}} artículos',
        cartFilled: 'Carrito ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Carrito vacío',
        billTitle: '¿Pedir la cuenta?',
        billHint: 'Elige cómo pagar. El camarero recibirá la notificación.',
        cash: 'Efectivo',
        cashHint: 'Pagar en efectivo en la mesa',
        card: 'Tarjeta',
        cardHint: 'Pagar con tarjeta (TPV)',
        billSentTitle: 'Cuenta solicitada',
        billSentHint: 'El camarero viene en un momento.',
        ok: 'OK',
        chooseVariant: 'Elige la variante',
        addToCart: 'Añadir al carrito',
        addProduct: 'Añadir',
        cartTitle: 'Carrito',
        total: 'Total',
        addToActiveOrder: 'Añadir al pedido activo',
        sendOrder: 'Enviar pedido',
        orderSentTitle: '¡Pedido enviado!',
        orderSentHint: 'Camarero notificado. #{{id}}',
        thanks: 'Gracias',
        callWaiter: 'Llamar camarero',
        requestBill: 'Cuenta',
        waiterCalled: 'Camarero notificado. Llegará en un momento.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Alérgenos',
        description: 'Descripción',
        ingredients: 'Ingredientes',
        nutrition: 'Información nutricional',
        tags: 'Etiquetas',
        status: {
            PENDING: 'Nuevo', CONFIRMED: 'Confirmado', IN_KITCHEN: 'En cocina',
            READY: 'Listo', SERVED: 'Servido', PAID: 'Pagado', CANCELLED: 'Cancelado',
        },
    },
    bg: {
        language: 'Език',
        previewError: 'Преглед на менюто не е наличен.',
        errorTitle: 'Хм 🤔',
        closedTitle: 'Ресторантът е затворен',
        closedFallback: 'QR поръчките не са налични в момента.',
        table: 'Маса',
        welcome: 'Добре дошли! Разгледайте менюто — поръчката отива директно в кухнята.',
        hoursToday: 'Работно време днес',
        activeOrder: 'Активна поръчка (#{{id}}). Новите артикули ще бъдат добавени.',
        fromPrice: 'от',
        emptyCategory: 'Категорията е празна.',
        yourOrders: 'Вашите поръчки',
        orderItems: '{{count}} артикула',
        cartFilled: 'Количка ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Празна количка',
        billTitle: 'Да поискате сметката?',
        billHint: 'Изберете начин на плащане. Сервитьорът ще бъде уведомен.',
        cash: 'В брой',
        cashHint: 'Плащане в брой на масата',
        card: 'Карта',
        cardHint: 'Плащане с карта (POS)',
        billSentTitle: 'Сметката е поискана',
        billSentHint: 'Сервитьорът идва след малко.',
        ok: 'OK',
        chooseVariant: 'Изберете вариант',
        addToCart: 'Добави в количката',
        addProduct: 'Добави',
        cartTitle: 'Количка',
        total: 'Общо',
        addToActiveOrder: 'Добави към активната поръчка',
        sendOrder: 'Изпрати поръчката',
        orderSentTitle: 'Поръчката е изпратена!',
        orderSentHint: 'Сервитьорът е уведомен. #{{id}}',
        thanks: 'Благодаря',
        callWaiter: 'Повикай сервитьор',
        requestBill: 'Сметка',
        waiterCalled: 'Сервитьорът е уведомен. Идва след малко.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Алергени',
        description: 'Описание',
        ingredients: 'Съставки',
        nutrition: 'Хранителни стойности',
        tags: 'Етикети',
        status: {
            PENDING: 'Нова', CONFIRMED: 'Потвърдена', IN_KITCHEN: 'В кухнята',
            READY: 'Готова', SERVED: 'Сервирана', PAID: 'Платена', CANCELLED: 'Отменена',
        },
    },
    tr: {
        language: 'Dil',
        previewError: 'Menü önizlemesi kullanılamıyor.',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'Restoran kapalı',
        closedFallback: 'QR sipariş şu anda kullanılamıyor.',
        table: 'Masa',
        welcome: 'Hoş geldiniz! Menüden seçin — siparişiniz doğrudan mutfağa gider.',
        hoursToday: 'Bugünkü saatler',
        activeOrder: 'Aktif siparişiniz var (#{{id}}). Yeni ürünler buna eklenecek.',
        fromPrice: 'başlangıç',
        emptyCategory: 'Bu kategori boş.',
        yourOrders: 'Siparişleriniz',
        orderItems: '{{count}} ürün',
        cartFilled: 'Sepet ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'Sepet boş',
        billTitle: 'Hesap ister misiniz?',
        billHint: 'Ödeme yöntemini seçin. Garson bilgilendirilecek.',
        cash: 'Nakit',
        cashHint: 'Masada nakit ödeme',
        card: 'Kart',
        cardHint: 'Kartla ödeme (POS)',
        billSentTitle: 'Hesap istendi',
        billSentHint: 'Garson birazdan gelecek.',
        ok: 'Tamam',
        chooseVariant: 'Boyut seçin',
        addToCart: 'Sepete ekle',
        addProduct: 'Ürünü ekle',
        cartTitle: 'Sepet',
        total: 'Toplam',
        addToActiveOrder: 'Aktif siparişe ekle',
        sendOrder: 'Siparişi gönder',
        orderSentTitle: 'Sipariş gönderildi!',
        orderSentHint: 'Garson bilgilendirildi. #{{id}}',
        thanks: 'Teşekkürler',
        callWaiter: 'Garson çağır',
        requestBill: 'Hesap',
        waiterCalled: 'Garson bilgilendirildi. Birazdan gelecek.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'Alerjenler',
        description: 'Açıklama',
        ingredients: 'Malzemeler',
        nutrition: 'Besin değerleri',
        tags: 'Etiketler',
        status: {
            PENDING: 'Yeni', CONFIRMED: 'Onaylandı', IN_KITCHEN: 'Mutfakta',
            READY: 'Hazır', SERVED: 'Servis edildi', PAID: 'Ödendi', CANCELLED: 'İptal',
        },
    },
    zh: {
        language: '语言',
        previewError: '菜单预览不可用。',
        errorTitle: '嗯 🤔',
        closedTitle: '餐厅已关闭',
        closedFallback: '目前无法通过二维码点餐。',
        table: '桌号',
        welcome: '欢迎！浏览菜单 — 订单直接送到厨房。',
        hoursToday: '今日营业时间',
        activeOrder: '您有进行中的订单 (#{{id}})。新商品将添加到此订单。',
        fromPrice: '起',
        emptyCategory: '此分类暂无菜品。',
        yourOrders: '您的订单',
        orderItems: '{{count}} 项',
        cartFilled: '购物车 ({{count}}) · {{total}} {{currency}}',
        cartEmpty: '购物车为空',
        billTitle: '需要结账吗？',
        billHint: '选择付款方式，服务员将收到通知。',
        cash: '现金',
        cashHint: '桌边现金支付',
        card: '银行卡',
        cardHint: '刷卡支付 (POS)',
        billSentTitle: '已请求结账',
        billSentHint: '服务员马上过来。',
        ok: '好的',
        chooseVariant: '选择规格',
        addToCart: '加入购物车',
        addProduct: '添加商品',
        cartTitle: '购物车',
        total: '合计',
        addToActiveOrder: '添加到当前订单',
        sendOrder: '提交订单',
        orderSentTitle: '订单已发送！',
        orderSentHint: '已通知服务员。#{{id}}',
        thanks: '谢谢',
        callWaiter: '呼叫服务员',
        requestBill: '结账',
        waiterCalled: '已通知服务员，马上过来。',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: '过敏原',
        description: '描述',
        ingredients: '配料',
        nutrition: '营养成分',
        tags: '标签',
        status: {
            PENDING: '新订单', CONFIRMED: '已确认', IN_KITCHEN: '制作中',
            READY: '已完成', SERVED: '已上菜', PAID: '已付款', CANCELLED: '已取消',
        },
    },
    ja: {
        language: '言語',
        previewError: 'メニュープレビューは利用できません。',
        errorTitle: 'Hmm 🤔',
        closedTitle: 'レストラン休業中',
        closedFallback: '現在QR注文はご利用いただけません。',
        table: 'テーブル',
        welcome: 'ようこそ！メニューから注文 — 厨房へ直接届きます。',
        hoursToday: '本日の営業時間',
        activeOrder: '進行中の注文があります (#{{id}})。追加商品はこの注文に含まれます。',
        fromPrice: '〜',
        emptyCategory: 'このカテゴリは空です。',
        yourOrders: 'ご注文',
        orderItems: '{{count}} 品',
        cartFilled: 'カート ({{count}}) · {{total}} {{currency}}',
        cartEmpty: 'カートは空です',
        billTitle: 'お会計ですか？',
        billHint: 'お支払い方法を選択してください。スタッフに通知されます。',
        cash: '現金',
        cashHint: 'テーブルで現金払い',
        card: 'カード',
        cardHint: 'カード払い (POS)',
        billSentTitle: 'お会計を依頼しました',
        billSentHint: 'スタッフがまもなく参ります。',
        ok: 'OK',
        chooseVariant: 'サイズを選択',
        addToCart: 'カートに追加',
        addProduct: '商品を追加',
        cartTitle: 'カート',
        total: '合計',
        addToActiveOrder: '進行中の注文に追加',
        sendOrder: '注文を送信',
        orderSentTitle: '注文を送信しました！',
        orderSentHint: 'スタッフに通知しました。#{{id}}',
        thanks: 'ありがとうございます',
        callWaiter: 'スタッフを呼ぶ',
        requestBill: 'お会計',
        waiterCalled: 'スタッフに通知しました。まもなく参ります。',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: 'アレルゲン',
        description: '説明',
        ingredients: '材料',
        nutrition: '栄養成分',
        tags: 'タグ',
        status: {
            PENDING: '新規', CONFIRMED: '確認済', IN_KITCHEN: '調理中',
            READY: '完成', SERVED: '提供済', PAID: '支払済', CANCELLED: 'キャンセル',
        },
    },
    ko: {
        language: '언어',
        previewError: '메뉴 미리보기를 사용할 수 없습니다.',
        errorTitle: 'Hmm 🤔',
        closedTitle: '레스토랑 영업 종료',
        closedFallback: '현재 QR 주문을 이용할 수 없습니다.',
        table: '테이블',
        welcome: '환영합니다! 메뉴에서 주문하세요 — 주방으로 바로 전달됩니다.',
        hoursToday: '오늘 영업시간',
        activeOrder: '진행 중인 주문이 있습니다 (#{{id}}). 새 항목이 추가됩니다.',
        fromPrice: '부터',
        emptyCategory: '이 카테고리가 비어 있습니다.',
        yourOrders: '주문 내역',
        orderItems: '{{count}}개',
        cartFilled: '장바구니 ({{count}}) · {{total}} {{currency}}',
        cartEmpty: '장바구니 비어 있음',
        billTitle: '계산서를 요청하시겠습니까?',
        billHint: '결제 방법을 선택하세요. 웨이터에게 알림이 갑니다.',
        cash: '현금',
        cashHint: '테이블에서 현금 결제',
        card: '카드',
        cardHint: '카드 결제 (POS)',
        billSentTitle: '계산서 요청됨',
        billSentHint: '웨이터가 곧 옵니다.',
        ok: '확인',
        chooseVariant: '옵션 선택',
        addToCart: '장바구니에 추가',
        addProduct: '상품 추가',
        cartTitle: '장바구니',
        total: '합계',
        addToActiveOrder: '진행 중인 주문에 추가',
        sendOrder: '주문하기',
        orderSentTitle: '주문이 전송되었습니다!',
        orderSentHint: '웨이터에게 알림을 보냈습니다. #{{id}}',
        thanks: '감사합니다',
        callWaiter: '웨이터 호출',
        requestBill: '계산서',
        waiterCalled: '웨이터에게 알림을 보냈습니다. 곧 옵니다.',
        caloriesPer100g: '{{n}} kcal / 100g',
        allergens: '알레르기',
        description: '설명',
        ingredients: '재료',
        nutrition: '영양 정보',
        tags: '태그',
        status: {
            PENDING: '신규', CONFIRMED: '확인됨', IN_KITCHEN: '조리 중',
            READY: '준비됨', SERVED: '서빙됨', PAID: '결제됨', CANCELLED: '취소됨',
        },
    },
};

export function menuLangStorageKey(slug) {
    return `menu_lang_${slug}`;
}

export function getMenuStrings(lang) {
    return STRINGS[lang] || STRINGS.en || STRINGS.ro;
}

function normalizeBrowserLang(navigatorLang) {
    const raw = (navigatorLang || (typeof navigator !== 'undefined' ? navigator.language : '') || '').toLowerCase();
    if (raw.startsWith('zh')) return 'zh';
    if (raw.startsWith('ja')) return 'ja';
    if (raw.startsWith('ko')) return 'ko';
    if (raw.startsWith('tr')) return 'tr';
    return raw.slice(0, 2);
}

export function interpolate(template, vars = {}) {
    return String(template).replace(/\{\{(\w+)\}\}/g, (_, key) => (
        vars[key] != null ? String(vars[key]) : ''
    ));
}

export function resolveClientMenuLang({ slug, enabled = ['ro', 'en'], urlLang, navigatorLang }) {
    const allowed = (enabled?.length ? enabled : ['ro', 'en']).filter((code) => MENU_LANG_META[code]);
    if (urlLang && allowed.includes(urlLang)) return urlLang;
    try {
        const stored = localStorage.getItem(menuLangStorageKey(slug));
        if (stored && allowed.includes(stored)) return stored;
    } catch {}
    const nav = normalizeBrowserLang(navigatorLang);
    if (allowed.includes(nav)) return nav;
    return allowed.includes('ro') ? 'ro' : allowed[0];
}

export function persistClientMenuLang(slug, lang) {
    try {
        localStorage.setItem(menuLangStorageKey(slug), lang);
    } catch {}
}

export function createMenuT(lang) {
    const strings = getMenuStrings(lang);
    return (key, vars) => {
        const parts = key.split('.');
        let value = strings;
        for (const part of parts) value = value?.[part];
        if (typeof value !== 'string') return key;
        return interpolate(value, vars);
    };
}
